import {post} from './httpBase'
//添加起止区域
export function getbillofdriver(params) {
    // return post('/areaMLine/addAreaLine', params)
    return post('/order/shuntorder/getbillofdriver', params)
}



// WEBPACK FOOTER //
// ./src/service/datastatistics.js